/**********************************************************/
/*  @name       VICTORY digital                           */
/*	@copyright	VICTORY group                             */
/*	@support	https://victoryagency.ru/digital          */
/**********************************************************/

import { slideUp, slideDown, slideToggle } from "../lib/collapse.js";

function stickyNav() {
  const nav = document.querySelector(".nav");

  /* sticky nav */

  if (nav && typeof nav !== "undefined") {
    window.scrollY > 200
      ? nav.classList.add("scroll")
      : nav.classList.remove("scroll");

    let lastScroll = 0;
    window.onscroll = function () {
      if (window.scrollY > 200 && window.scrollY > lastScroll) {
        nav.classList.add("scroll");
      } else {
        nav.classList.remove("scroll");
      }
      lastScroll = window.scrollY;
    };
    document.body.style.setProperty("--headerHeight", nav.clientHeight + "px");
  }
}

function mobileMenu() {
  const nav = document.querySelector(".nav");
  const menuButton = document.querySelector(".js-toggle-menu");
  const mobileSide = document.querySelector(".mobile-side");
  const mainMenu = document.querySelector(".nav__menu");
  const navTop = document.querySelector(".nav__top");
  const navMiddle = document.querySelector(".nav__middle");

  if (!menuButton || !mobileSide) return;

  if (window.innerWidth <= 768) {
    mobileSide.querySelector(".mobile-side__inner").appendChild(mainMenu);
    mobileSide.querySelector(".mobile-side__inner").appendChild(navTop);
  } else {
    navMiddle.appendChild(mainMenu);
    nav.prepend(navTop);
  }

  menuButton.addEventListener("click", () => {
    document.body.classList.toggle("menu-open");
    menuButton.classList.toggle("active");
    mobileSide.classList.toggle("active");
  });
}

export function headerNavigation() {
  mobileMenu();
  stickyNav();
}

window.addEventListener("resize", () => {
  mobileMenu();
});
